import { render, staticRenderFns } from "./combinpagetwo.vue?vue&type=template&id=2637f6ec&scoped=true"
import script from "./combinpagetwo.vue?vue&type=script&lang=js"
export * from "./combinpagetwo.vue?vue&type=script&lang=js"
import style0 from "./combinpagetwo.vue?vue&type=style&index=0&id=2637f6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2637f6ec",
  null
  
)

export default component.exports